<div [classList]="containerClassToAplly() + (hasGlobalMessages() ? '-global-message' : '')">

  <app-notification></app-notification>

  @defer(on timer(0.5s)) {
  <app-global-message class="sticky-top animated fadeInDown"></app-global-message>
  }

  @if (showAppHeader()) {
  <app-header class="sticky-top header"></app-header>
  }

  @if (isShopComponent()) {
  @if (isMobile()) {
  <app-categories-dropdown></app-categories-dropdown>
  }

  <app-shop-header [class.cart-preview-showing]="showAppCartPreview()"></app-shop-header>
  }

  @defer (on timer(0.5s)) {
  @if (!isMobile()) {
  <div class="cart-preview"
    [ngClass]="{'cart-preview--height': !hasGlobalMessages(), 'cart-preview--height-global-message': hasGlobalMessages()}"
    [class.open]="showAppCartPreview()">
    <app-side-checkout></app-side-checkout>
  </div>
  }
  }

  @if(showAppCartPreview()){
  <div class="backdrop-cart-preview" (click)="showCartPreview.set(false)"></div>
  }

  <div class="main-container" appScrollToTop name="scroll-to-top-ref"
    [class.header-showing]="showAppHeader() && !hasGlobalMessages()"
    [class.header-showing-global-message]="showAppHeader() && hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav]="!shouldShowCategoriesBar() && !hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav-global-message]="!shouldShowCategoriesBar() && hasGlobalMessages()"
    [class.cart-preview-showing]="showAppCartPreview()" [class.mobile-main-container]="showMobileFooter()"
    [class.with-shop-nav-only]="isShopComponent()" [class.hidden-mobile-footer]="!showMobileFooter()">
    <router-outlet />
  </div>

  @if (showMobileFooter()) {
  <app-mobile-footer-menu></app-mobile-footer-menu>
  }

  @if (loadingService.isShowGlobalLoading()) {
  <app-loading></app-loading>
  }

</div>